import { gql } from '@apollo/client';

const ORDER_FOR_INVOICE = gql`
    query OrderForInvoice($publicId: ID!, $total: Float!) {
        orderForInvoice(publicId: $publicId, total: $total) {
            date
            found
            message
            canRequest
            total
        }
    }
`;

export default ORDER_FOR_INVOICE;
